import './Divider.css';

export default function Divider() {
    return (
        <div className='inner-divider mb-3'></div>
    )
}